var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import * as echarts from "echarts";
import OperationReportService from '../../api/OperationReportService';
var LossAnastleDetails = (function (_super) {
    __extends(LossAnastleDetails, _super);
    function LossAnastleDetails() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rowId = null;
        _this.siiData = [];
        _this.simData = [];
        _this.soiData = [];
        _this.somData = [];
        _this.sorData = [];
        _this.option = {
            xAxis: {
                position: 'bottom',
                type: 'category',
                name: '日期',
                data: [],
                axisLine: {
                    onZero: false
                }
            },
            yAxis: {
                type: 'value',
                name: '损耗差异'
            },
            tooltip: {
                formatter: function (params) {
                    var htmlstr = "<div>" + params.data + "\u4E2A</br>\u65E5\u671F\uFF1A" + params.name + "</div>";
                    return htmlstr;
                }
            },
            legend: {
                orient: 'vertical',
                x: 'right',
                padding: [50, 0, 0, 150],
                top: '10%',
                data: ['库存报溢', '库存报损', "盘点报溢", "盘点报损", "退货报损"]
            },
            color: ['#FF1A42', '#FF902C', '#741AD5', '#D22CFF', '#08BD06'],
            series: [{
                    name: '库存报溢',
                    type: 'line',
                    data: _this.simData,
                },
                {
                    name: '库存报损',
                    type: 'line',
                    data: _this.somData,
                }, {
                    name: '盘点报溢',
                    type: 'line',
                    data: _this.siiData,
                },
                {
                    name: '盘点报损',
                    type: 'line',
                    data: _this.soiData,
                },
                {
                    name: '退货报损',
                    type: 'line',
                    data: _this.sorData,
                }]
        };
        return _this;
    }
    LossAnastleDetails.prototype.mounted = function () {
        this.service = OperationReportService.getInstance();
        this.getEcharts();
    };
    LossAnastleDetails.prototype.getEcharts = function () {
        var _this = this;
        var params = {
            s_time: this.rowId.s_time ? this.rowId.s_time : undefined,
            e_time: this.rowId.e_time ? this.rowId.e_time : undefined,
            depot_id: this.rowId.depot_id ? this.rowId.depot_id : undefined,
            goods_format_id: this.rowId.goods_format_id ? this.rowId.goods_format_id : undefined,
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getAnasyleDetails(params).then(function (res) {
            var chartData = res.data.data;
            _this.InitChart(chartData);
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    LossAnastleDetails.prototype.InitChart = function (chartData) {
        var _this = this;
        this.chart = echarts.init(this.$refs.LossChart);
        var xAxisData = [];
        chartData.forEach(function (item) {
            xAxisData.push(item.date);
            _this.somData.push(item.som_amount);
            _this.simData.push(item.sim_amount);
            _this.soiData.push(item.soi_amount);
            _this.siiData.push(item.sii_amount);
            _this.sorData.push(item.sor_amount);
        });
        this.option.xAxis.data = xAxisData;
        this.chart.setOption(this.option, true);
    };
    LossAnastleDetails = __decorate([
        Component({
            components: {},
            methods: {},
        })
    ], LossAnastleDetails);
    return LossAnastleDetails;
}(Vue));
export default LossAnastleDetails;
